export { default as ChecklessPayments } from 'reservations/preDining/components/ChecklessPaymentsModule';
export { default as Location } from 'reservations/preDining/components/LocationModule';
export { default as Menu } from 'reservations/preDining/components/MenuModule';
export { default as ReservationDetails } from 'reservations/preDining/components/ReservationDetailsModule';
export { default as Text } from 'reservations/preDining/components/TextModule';
export { default as Image } from 'reservations/preDining/components/ImageModule';
export { default as Instagram } from 'reservations/preDining/components/InstagramModule';
export { default as ImageCarousel } from 'reservations/preDining/components/ImageCarouselModule';
